class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.endDate = element.getAttribute('data-end-date');
    this.daysEl = element.querySelector('[data-timer-days]');
    this.hoursEl = element.querySelector('[data-timer-hours]');
    this.minutesEl = element.querySelector('[data-timer-minutes]');
    this.secondsEl = element.querySelector('[data-timer-seconds]');
    
    if (!this.endDate) {
      console.error('Countdown timer: No end date provided');
      return;
    }
    
    this.init();
  }
  
  init() {
    // Parse the date string (format: YYYY-MM-DD HH:MM)
    const dateTimeParts = this.endDate.trim().split(' ');
    if (dateTimeParts.length !== 2) {
      console.error('Countdown timer: Invalid date format. Use YYYY-MM-DD HH:MM');
      return;
    }
    
    const [datePart, timePart] = dateTimeParts;
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);
    
    // Create date object (month is 0-indexed in JavaScript)
    this.targetDate = new Date(year, month - 1, day, hours, minutes, 0);
    
    if (isNaN(this.targetDate.getTime())) {
      console.error('Countdown timer: Invalid date');
      return;
    }
    
    // Start the countdown
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }
  
  updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetDate.getTime() - now;
    
    if (distance < 0) {
      // Timer has ended
      this.daysEl.textContent = '00';
      this.hoursEl.textContent = '00';
      this.minutesEl.textContent = '00';
      this.secondsEl.textContent = '00';
      clearInterval(this.interval);
      return;
    }
    
    // Calculate time units
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    // Update DOM with padded values
    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
  
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize all countdown timers on the page
function initCountdownTimers() {
  const timers = document.querySelectorAll('.countdown-timer');
  timers.forEach(timer => {
    if (!timer.countdownInstance) {
      timer.countdownInstance = new CountdownTimer(timer);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdownTimers);
} else {
  initCountdownTimers();
}

// Re-initialize when Shopify theme editor updates sections
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCountdownTimers);
  document.addEventListener('shopify:section:reorder', initCountdownTimers);
}
